/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./admin.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "../../core/achoo-iframe/achoo-iframe.component.ngfactory";
import * as i3 from "../../core/achoo-iframe/achoo-iframe.component";
import * as i4 from "@angular/platform-browser";
import * as i5 from "@angular/router";
import * as i6 from "./admin.component";
import * as i7 from "../../services/user.service";
var styles_AdminComponent = [i0.styles];
var RenderType_AdminComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_AdminComponent, data: {} });
export { RenderType_AdminComponent as RenderType_AdminComponent };
export function View_AdminComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "achoo-iframe", [], null, null, null, i2.View_AchooIframeComponent_0, i2.RenderType_AchooIframeComponent)), i1.ɵdid(1, 114688, null, 0, i3.AchooIframeComponent, [i4.DomSanitizer, i5.Router], { source: [0, "source"] }, null)], function (_ck, _v) { var _co = _v.component; var currVal_0 = _co.route; _ck(_v, 1, 0, currVal_0); }, null); }
export function View_AdminComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "admin-content", [], null, null, null, View_AdminComponent_0, RenderType_AdminComponent)), i1.ɵdid(1, 12828672, null, 0, i6.AdminComponent, [i7.UserService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var AdminComponentNgFactory = i1.ɵccf("admin-content", i6.AdminComponent, View_AdminComponent_Host_0, {}, {}, []);
export { AdminComponentNgFactory as AdminComponentNgFactory };



// WEBPACK FOOTER //
// ./src/app/main/admin/admin.component.ngfactory.js.pre-build-optimizer.js